export default "__VITE_ASSET__CFFRNPDk__"